<div class="main-container">
    <mat-card style="padding-top: 10px;">
        <mat-card-title>Login</mat-card-title>
        <mat-card-content>
            <div class="login-container" style="display: flex; flex-direction: column; align-items: center;">
                <form [formGroup]="form" (ngSubmit)="submit()" style="width: 100%;">
                    <p>
                        <mat-form-field style="width: 100%;">
                            <input type="text" matInput placeholder="Username" formControlName="username">
                        </mat-form-field>
                    </p>

                    <p>
                        <mat-form-field style="width: 100%;">
                            <input type="password" matInput placeholder="Password" formControlName="password">
                        </mat-form-field>
                    </p>

                    <p *ngIf="error" style="color: #c62828; margin: 0 0 12px; font-size: 13px;">{{ error }}</p>

                    <div class="button" style="margin-bottom: 12px; width: 100%;">
                        <button style="width: 100%;" mat-button mat-raised-button [color]="'primary'" type="submit">Login</button>
                    </div>
                </form>
            </div>
        </mat-card-content>
    </mat-card>
</div>
